/**
 *  G E T T E R S
 *  https://vuex.vuejs.org/en/getters.html
 */

const getters = {
  /*   T O K E N   */
  getUserToken: state => {
    if (state.token != null) {
      return state.token
    }
    if (sessionStorage.getItem('token') != null) {
      return sessionStorage.getItem('token')
    }
    return null
  },

  /*   A C C O U N T   */
  getAccount: state => {
    if (state.account != null) {
      if (state.account.account_id) {
        return state.account
      }
    }
    let obj = sessionStorage.getItem('account')
    if (obj != null && obj != 'undefined' && typeof obj != 'undefined') {
      // reset ??
      // state.account = JSON.parse(obj)
      return JSON.parse(obj)
    }
    return null
  },

  isLoggedIn: (state, getters) => {
    // console.log('isLoggedIn, getters.getAccount=', getters.getAccount)
    return getters.getAccount != null
  },

  getRoles: (state, getters) => {
    if (getters.isLoggedIn) {
      return getters.getAccount.roles
    }
    return null
  },

  isUserAdmin: (state, getters) => {
    if (getters.isLoggedIn) {
      let roles = getters.getRoles
      if (roles != null) {
        return roles.indexOf('ROLE_ADMIN') > -1
      }
    }
    return false
  },

  hasAccess: (state, getters) => feature => {
    let roles = getters.getRoles
    if (roles != null) {
      // no roles, no access
      if (roles.length == 0) {
        return false
      }
      // if super, all access
      if (roles.indexOf('ROLE_SUPER_ADMIN') > -1) {
        return true
      }
      // check specific role
      if (roles.indexOf('ROLE_' + feature) > -1) {
        return true
      }
    }
    return false
  },

  /*   F A C I L I T Y    */
  getFacility: state => {
    if (state.facility != null) {
      if (state.facility.facility_id) {
        return state.facility
      }
    }
    let obj = sessionStorage.getItem('facility')
    if (obj != null && obj != 'undefined' && typeof obj != 'undefined') {
      // reset state?
      return JSON.parse(obj)
    }
    return null
  },

  isFacilityAssigned: (state, getters) => {
    return getters.getFacility != null
  },

  getFacilityId: (state, getters) => {
    if (getters.isFacilityAssigned) {
      return getters.getFacility.facility_id
    }
  },

  getFacilityName: (state, getters) => {
    if (getters.isFacilityAssigned) {
      return getters.getFacility.description
    }
  },
  getFacilityAddress: (state, getters) => {
    if (getters.isFacilityAssigned) {
      if (getters.getFacility.address2) {
        return getters.getFacility.address1 + ' ' + getters.getFacility.address2
      }
      return getters.getFacility.address1
    }
  },
  getFacilityCityStateZip: (state, getters) => {
    if (getters.isFacilityAssigned) {
      return (
        getters.getFacility.city +
        ', ' +
        getters.getFacility.state +
        ' ' +
        getters.getFacility.zipcode
      )
    }
  },
  getFacilityTimezone: (state, getters) => {
    if (getters.isFacilityAssigned) {
      return getters.getFacility.timezone
    }
  },

  getFacilityThreshold: state => {
    if (state.facilityThreshold) {
      return state.facilityThreshold
    }
    return sessionStorage.getItem('threshold')
  },

  /*    ( M U L T I )  F A C I L I T Y   S U P P O R T  */

  getFacilities: state => {
    if (state.facilities != null) {
      if (state.facilities.length > 0) {
        return state.facilities
      }
    }
    let obj = sessionStorage.getItem('facilities')
    if (obj != null && obj != 'undefined' && typeof obj != 'undefined') {
      return JSON.parse(obj)
    }
    return null
  },

  getFacilityCount: (state, getters) => {
    if (getters.getFacilities != null) {
      return getters.getFacilities.length
    }
    return 0
  },

  isMultiFacility: (state, getters) => {
    return getters.getFacilityCount > 1
  },

  /*   P R O G A M S   */
  getPrograms: state => {
    if (state.programs != null) {
      if (state.programs.length > 0) {
        return state.programs
      }
    }
    let obj = sessionStorage.getItem('programs')
    if (obj != null && obj != 'undefined' && typeof obj != 'undefined') {
      return JSON.parse(obj)
    }
    return null
  },

  hasProgram: (state, getters) => program => {
    let programs = getters.getPrograms
    if (programs != null) {
      if (programs.length > 0) {
        for (var pr = 0; pr < programs.length; pr++) {
          if (programs[pr].description.indexOf(program) > -1) {
            return true
          }
        }
      }
    }
    return false
  },

  /*   U T I L I T Y    */
  getUtility: state => {
    if (state.utility != null) {
      if (state.utility.utility_id) {
        return state.utility
      }
    }
    let obj = sessionStorage.getItem('utility')
    if (obj != null && obj != 'undefined' && typeof obj != 'undefined') {
      return JSON.parse(obj)
    }
    return null
  },

  isUtilityAssigned: (state, getters) => {
    return getters.getUtility != null
  },

  getUtilityId: (state, getters) => {
    if (getters.isUtilityAssigned) {
      return getters.getUtility.utility_id
    }
  },

  getUtilityName: (state, getters) => {
    if (getters.isUtilityAssigned) {
      return getters.getUtility.description
    }
  },

  /*   I S O   */
  getIso: state => {
    if (state.iso != null) {
      if (state.iso.iso_id) {
        return state.iso
      }
    }
    let obj = sessionStorage.getItem('iso')
    if (obj != null && obj != 'undefined' && typeof obj != 'undefined') {
      return JSON.parse(obj)
    }
    return null
  },

  isIsoAssigned: (state, getters) => {
    return getters.getIso != null
  },

  getIsoId: (state, getters) => {
    if (getters.isIsoAssigned) {
      return getters.getIso.iso_id
    }
  },

  getIsoName: (state, getters) => {
    if (getters.isIsoAssigned) {
      return getters.getIso.description
    }
  },

  /*   P R O G R A M S   */

  /*   N C P   C E I L I N G   */
  getNcpCeiling: state => {
    if (state.ncpCeiling != null) {
      return state.ncpCeiling
    }
    let obj = sessionStorage.getItem('ncpCeiling')
    if (obj != null && obj != 'undefined' && typeof obj != 'undefined') {
      return parseInt(obj)
    }
    return null
  },

  /*   M I S C   */
  getPrevailingTimezone: (state, getters) => {
    if (getters.isFacilityAssigned) {
      let tz = getters.getFacilityTimezone
      if (tz == 'America/New_York') {
        return 'EPT'
      }
      if (tz == 'America/Chicago') {
        return 'CPT'
      }
      if (tz == 'America/Denver') {
        return 'MPT'
      }
      if (tz == 'America/Los_Angeles') {
        return 'PPT'
      }
    }
    return ''
  }
}

export default getters
